// extracted by mini-css-extract-plugin
module.exports = {"updatePassword":"styles_updatePassword__QCtju","btnForm":"styles_btnForm__wdzQ9"};